// Extension pages keep their own tab strips; resetting the Collections strip leaves them alone.
export const EXTENSION_STRIP_TAB_TYPES = new Set(['db-manager-table', 'task-manager-board', 'projects-project', 'document-editor']);

export const newTabId = () =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `t-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
